import styled from 'styled-components';

import Link from '@ntuctech/devex-tangram/Link';

const ErrorLink = styled(Link)`
  &:link,
  &:visited,
  &:hover,
  &:active {
    color: ${(props) => props.theme.ColorFontInputLabelError};
    font-weight: normal;
    box-shadow: 0 0.0625rem ${(props) => props.theme.ColorFontInputLabelError};
  }
`;

export default ErrorLink;
